import React from 'react';
import _ChangePasswordForm from './_ChangePasswordForm.scss';
import {Input} from 'components/vitrade-forms/common';
import {withRouter} from 'react-router-dom';
import {toastr} from 'react-redux-toastr';
import { User } from 'api';
import {connect} from 'react-redux';

class ChangePasswordForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formChangePassword'] = [];

    this.state = {

    }
  }

  postChange(e) {
    e.preventDefault();

    // validation
    toastr.removeByType('error');
    if (!this.refs.oldPassword.validator.input.value) {
      toastr.error("Lỗi", "Bạn vui lòng nhập vào mật khẩu cũ");
      return;
    } else if (!this.refs.password.validator.input.value) {
      toastr.error("Lỗi", "Bạn vui lòng nhập vào mật khẩu mới");
      return;
    } else if (this.refs.password.validator.input.value != this.refs.repassword.validator.input.value) {
      toastr.error("Lỗi", "2 mật khẩu mới nhập không trùng khớp");
      return;
    }

    User.actions.changePass.request({}, {
      data: {
        oldPassword: this.refs.oldPassword.validator.input.value,
        newPassword: this.refs.password.validator.input.value
      }
    }).then(response => {
      toastr.success("Thành công", "Mật khẩu đã được cập nhật thành công");
      this.props.history.push("/profile");
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.error.code == "INVALID_PASSWORD") {
        toastr.error("Lỗi", "Mật khẩu cũ không đúng")
      }
    })
  }

  render() {
    return (
      <div className="change-pass-form box-wrap">
        <form onSubmit={this.postChange.bind(this)}>
          <Input type="password" placeholder="Mật khẩu cũ..."
            className='has-feedback fg-custom'
            iconClassName='fa-unlock-alt'
            ref='oldPassword'
          />

          <Input type="password" placeholder="Mật khẩu mới..."
            className='has-feedback fg-custom'
            iconClassName='fa-unlock-alt'
            ref='password'
          />
          <Input type="password" placeholder="Nhập lại mật khẩu mới..."
            className='has-feedback fg-custom'
            iconClassName='fa-unlock-alt'
            ref='repassword'
          />
          <div>
            <button type="submit" className="update-btn">XÁC NHẬN ĐỔI</button>
          </div>
        </form>
      </div>
    );
  }
}

ChangePasswordForm.defaultProps = {
  validators: {}
}

const bindStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(bindStateToProps)(ChangePasswordForm));;



// WEBPACK FOOTER //
// ./components/users/sub-view/change-password-form/ChangePasswordForm.jsx